import { TemplateTextColor } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: templateTextColors,
  selectors: templateTextColorsSelector,
} = createEntitySlice<TemplateTextColor>("templateTextColors")
